import { Menu, X } from 'lucide-react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';

export function Nav() {
  const [open, setOpen] = useState(false);
  const links = [['#leonardo','Leonardo'],['#archivo-vivo','Archivo Vivo'],['#acontecimientos','Acontecimientos'],['#colectivo','Archivo colectivo'],['#novedades','Novedades'],['#contacto','Contacto']];
  return <header className="site-nav">
    <nav className={open ? 'nav-links open' : 'nav-links'}>
      {links.map(([href,label]) => <a key={href} href={href} onClick={() => setOpen(false)}>{label}</a>)}
      <Link className="admin-link" to="/admin" onClick={() => setOpen(false)}>Admin</Link>
    </nav>
    <button className="nav-toggle" aria-label="Abrir navegación" onClick={() => setOpen(!open)}>{open ? <X/> : <Menu/>}</button>
  </header>;
}
